import { render, staticRenderFns } from "./deleteWorkType.vue?vue&type=template&id=fb4fb1ea&scoped=true"
import script from "./deleteWorkType.vue?vue&type=script&lang=js"
export * from "./deleteWorkType.vue?vue&type=script&lang=js"
import style0 from "./deleteWorkType.vue?vue&type=style&index=0&id=fb4fb1ea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb4fb1ea",
  null
  
)

export default component.exports